<template>
    <form class="auth-form" role="form" method="POST" action="/password/reset" @submit.prevent="submit" novalidate>        
        <form-input-type-email
            name="email"
            :label="__('Your email')"
            :value="email"
            disabled
            full-border
        ></form-input-type-email>

        <form-input-type-password 
            name="password"
            :label="__('New password')"
            :errors="errors.password"
            :note="__('The password must contain at least 10 characters and at least one upper and one lower case letter.')"
            required
            full-border
        ></form-input-type-password>

        <form-input-type-password 
            name="password_confirmation"
            :label="__('Repeat password')"
            :errors="errors.password_confirmation"
            required
            full-border
        ></form-input-type-password>

        <slot></slot>
    </form>
</template>

<script>
    export default {
        props: {
            email: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                errors: []
            }
        },
        mounted() {
            $('.auth-page').animate({ opacity: 1 }, 300)
            $('.login').animate({ opacity: 1 }, 300)
        },
        methods: {
            submit() {
                let data = {}

                // serialize form data
                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        data[name] = value
                    })

                data['email'] = this.email

                axios
                    .post('/password/reset', data)
                    .then(({ data }) => window.location.replace(data.redirect))
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>
